import { canSeeFindDonations } from 'src/utils/entryPoints';
import { freeUserUpgradeStep } from '../utils';

export const dashboardHomeNpoTour = {
  tourKey: 'dashboard_home_npo',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin', 'staff', 'driver'],
    plans: null,
  },
  steps: [
    {
      // No target - shows a centered welcome popover without highlighting any element
      title: 'tours.dashboard-home-business.welcome.title',
      content: 'tours.dashboard-home-npo.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="stats-food-rescued"]',
      title: 'tours.dashboard-home-npo.food-rescued.title',
      content: 'tours.dashboard-home-npo.food-rescued.content',
      placement: 'right',
    },
    {
      target: '[data-tour="stats-total-count"]',
      title: 'tours.dashboard-home-npo.total-rescues.title',
      content: 'tours.dashboard-home-npo.total-rescues.content',
      placement: 'right',
    },
    {
      target: '[data-tour="stats-impact"]',
      title: 'tours.dashboard-home-business.impact.title',
      content: 'tours.dashboard-home-npo.impact.content',
      placement: 'top',
    },
    {
      target: '[data-tour="sidebar-find-donations"]',
      title: 'tours.dashboard-home-npo.find-donations.title',
      content: 'tours.dashboard-home-npo.find-donations.content',
      placement: 'right',
      autoOpenSelector: '[data-tour="sidebar-toggle"]',
      showIf: (discriminators) => canSeeFindDonations(discriminators?.user),
    },
    {
      target: '[data-tour="sidebar-careit-id"]',
      title: 'tours.dashboard-home-npo.careit-id.title',
      content: 'tours.dashboard-home-npo.careit-id.content',
      placement: 'right',
      autoOpenSelector: '[data-tour="sidebar-toggle"]',
    },
    freeUserUpgradeStep,
  ],
};
